import { Typography, styled } from '@mui/material';

const StyledLargeSessionCardText = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(12)
  }
}));

export default StyledLargeSessionCardText;
